import { render, staticRenderFns } from "./Scrollbutton.vue?vue&type=template&id=1b430eb5&scoped=true&"
import script from "./Scrollbutton.vue?vue&type=script&lang=js&"
export * from "./Scrollbutton.vue?vue&type=script&lang=js&"
import style0 from "./Scrollbutton.vue?vue&type=style&index=0&id=1b430eb5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b430eb5",
  null
  
)

export default component.exports